/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * AGOS API
 * v1 is a faithful port of the HellKitchen Express API: same paths under /api/v1, same request and response shapes, same status codes and error messages.
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

import type {
  ChannelCoverage,
  CourierPushState,
  CourierPushSubscribeRequest,
  CourierPushUnsubscribeRequest,
  DailyCheckResult,
  EmailMessageTemplate,
  EventChannelsSaved,
  EventStrategySaved,
  GetNotificationsDeliveriesParams,
  GetNotificationsParams,
  NewNotification,
  NotificationChannelHealth,
  NotificationChannelSetting,
  NotificationChannels,
  NotificationDelivery,
  NotificationPage,
  NotificationTemplate,
  NotificationTestSent,
  NotificationUnreadCount,
  PostNotificationsTemplatesBody,
  PostNotificationsTestSendChannelBody,
  PushMessageTemplate,
  PutNotificationsChannelSettingsChannelBody,
  PutNotificationsChannelsEventKeyBody,
  PutNotificationsChannelsEventKeyStrategyBody,
  PutNotificationsEmailMessagesMessageKeyBody,
  PutNotificationsPushMessagesMessageKeyBody,
} from '../../model'

import { customFetch } from '../../../custom-fetch'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K }
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    })
  }
  return result
}

export const getPutNotificationsPushMessagesMessageKeyUrl = (messageKey: string) => {
  return `/api/v1/notifications/push-messages/${messageKey}`
}

/**
 * @summary Change the text of one push notification
 */
export const putNotificationsPushMessagesMessageKey = async (
  messageKey: string,
  putNotificationsPushMessagesMessageKeyBody?: PutNotificationsPushMessagesMessageKeyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<PushMessageTemplate> => {
  return customFetch<PushMessageTemplate>(
    getPutNotificationsPushMessagesMessageKeyUrl(messageKey),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putNotificationsPushMessagesMessageKeyBody),
    },
  )
}

export const getPutNotificationsPushMessagesMessageKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>,
    TError,
    { messageKey: string; data?: PutNotificationsPushMessagesMessageKeyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>,
  TError,
  { messageKey: string; data?: PutNotificationsPushMessagesMessageKeyBody },
  TContext
> => {
  const mutationKey = ['putNotificationsPushMessagesMessageKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>,
    { messageKey: string; data?: PutNotificationsPushMessagesMessageKeyBody }
  > = (props) => {
    const { messageKey, data } = props ?? {}

    return putNotificationsPushMessagesMessageKey(messageKey, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutNotificationsPushMessagesMessageKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>
>
export type PutNotificationsPushMessagesMessageKeyMutationBody =
  PutNotificationsPushMessagesMessageKeyBody | undefined
export type PutNotificationsPushMessagesMessageKeyMutationError = unknown

/**
 * @summary Change the text of one push notification
 */
export const usePutNotificationsPushMessagesMessageKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>,
      TError,
      { messageKey: string; data?: PutNotificationsPushMessagesMessageKeyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationsPushMessagesMessageKey>>,
  TError,
  { messageKey: string; data?: PutNotificationsPushMessagesMessageKeyBody },
  TContext
> => {
  return useMutation(getPutNotificationsPushMessagesMessageKeyMutationOptions(options), queryClient)
}
export const getPutNotificationsEmailMessagesMessageKeyUrl = (messageKey: string) => {
  return `/api/v1/notifications/email-messages/${messageKey}`
}

/**
 * @summary Change the text of one e-mail
 */
export const putNotificationsEmailMessagesMessageKey = async (
  messageKey: string,
  putNotificationsEmailMessagesMessageKeyBody?: PutNotificationsEmailMessagesMessageKeyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<EmailMessageTemplate> => {
  return customFetch<EmailMessageTemplate>(
    getPutNotificationsEmailMessagesMessageKeyUrl(messageKey),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putNotificationsEmailMessagesMessageKeyBody),
    },
  )
}

export const getPutNotificationsEmailMessagesMessageKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>,
    TError,
    { messageKey: string; data?: PutNotificationsEmailMessagesMessageKeyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>,
  TError,
  { messageKey: string; data?: PutNotificationsEmailMessagesMessageKeyBody },
  TContext
> => {
  const mutationKey = ['putNotificationsEmailMessagesMessageKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>,
    { messageKey: string; data?: PutNotificationsEmailMessagesMessageKeyBody }
  > = (props) => {
    const { messageKey, data } = props ?? {}

    return putNotificationsEmailMessagesMessageKey(messageKey, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutNotificationsEmailMessagesMessageKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>
>
export type PutNotificationsEmailMessagesMessageKeyMutationBody =
  PutNotificationsEmailMessagesMessageKeyBody | undefined
export type PutNotificationsEmailMessagesMessageKeyMutationError = unknown

/**
 * @summary Change the text of one e-mail
 */
export const usePutNotificationsEmailMessagesMessageKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>,
      TError,
      { messageKey: string; data?: PutNotificationsEmailMessagesMessageKeyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationsEmailMessagesMessageKey>>,
  TError,
  { messageKey: string; data?: PutNotificationsEmailMessagesMessageKeyBody },
  TContext
> => {
  return useMutation(
    getPutNotificationsEmailMessagesMessageKeyMutationOptions(options),
    queryClient,
  )
}
export const getPutNotificationsChannelsEventKeyUrl = (eventKey: string) => {
  return `/api/v1/notifications/channels/${eventKey}`
}

/**
 * @summary Change how one event reaches the customer
 */
export const putNotificationsChannelsEventKey = async (
  eventKey: string,
  putNotificationsChannelsEventKeyBody?: PutNotificationsChannelsEventKeyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<EventChannelsSaved> => {
  return customFetch<EventChannelsSaved>(getPutNotificationsChannelsEventKeyUrl(eventKey), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putNotificationsChannelsEventKeyBody),
  })
}

export const getPutNotificationsChannelsEventKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>,
    TError,
    { eventKey: string; data?: PutNotificationsChannelsEventKeyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>,
  TError,
  { eventKey: string; data?: PutNotificationsChannelsEventKeyBody },
  TContext
> => {
  const mutationKey = ['putNotificationsChannelsEventKey']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>,
    { eventKey: string; data?: PutNotificationsChannelsEventKeyBody }
  > = (props) => {
    const { eventKey, data } = props ?? {}

    return putNotificationsChannelsEventKey(eventKey, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutNotificationsChannelsEventKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>
>
export type PutNotificationsChannelsEventKeyMutationBody =
  PutNotificationsChannelsEventKeyBody | undefined
export type PutNotificationsChannelsEventKeyMutationError = unknown

/**
 * @summary Change how one event reaches the customer
 */
export const usePutNotificationsChannelsEventKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>,
      TError,
      { eventKey: string; data?: PutNotificationsChannelsEventKeyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKey>>,
  TError,
  { eventKey: string; data?: PutNotificationsChannelsEventKeyBody },
  TContext
> => {
  return useMutation(getPutNotificationsChannelsEventKeyMutationOptions(options), queryClient)
}
export const getPutNotificationsChannelsEventKeyStrategyUrl = (eventKey: string) => {
  return `/api/v1/notifications/channels/${eventKey}/strategy`
}

/**
 * @summary The strategy and channel order for one event
 */
export const putNotificationsChannelsEventKeyStrategy = async (
  eventKey: string,
  putNotificationsChannelsEventKeyStrategyBody: PutNotificationsChannelsEventKeyStrategyBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<EventStrategySaved> => {
  return customFetch<EventStrategySaved>(getPutNotificationsChannelsEventKeyStrategyUrl(eventKey), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(putNotificationsChannelsEventKeyStrategyBody),
  })
}

export const getPutNotificationsChannelsEventKeyStrategyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>,
    TError,
    { eventKey: string; data: PutNotificationsChannelsEventKeyStrategyBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>,
  TError,
  { eventKey: string; data: PutNotificationsChannelsEventKeyStrategyBody },
  TContext
> => {
  const mutationKey = ['putNotificationsChannelsEventKeyStrategy']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>,
    { eventKey: string; data: PutNotificationsChannelsEventKeyStrategyBody }
  > = (props) => {
    const { eventKey, data } = props ?? {}

    return putNotificationsChannelsEventKeyStrategy(eventKey, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutNotificationsChannelsEventKeyStrategyMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>
>
export type PutNotificationsChannelsEventKeyStrategyMutationBody =
  PutNotificationsChannelsEventKeyStrategyBody
export type PutNotificationsChannelsEventKeyStrategyMutationError = unknown

/**
 * @summary The strategy and channel order for one event
 */
export const usePutNotificationsChannelsEventKeyStrategy = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>,
      TError,
      { eventKey: string; data: PutNotificationsChannelsEventKeyStrategyBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationsChannelsEventKeyStrategy>>,
  TError,
  { eventKey: string; data: PutNotificationsChannelsEventKeyStrategyBody },
  TContext
> => {
  return useMutation(
    getPutNotificationsChannelsEventKeyStrategyMutationOptions(options),
    queryClient,
  )
}
export const getPutNotificationsChannelSettingsChannelUrl = (channel: string) => {
  return `/api/v1/notifications/channel-settings/${channel}`
}

/**
 * @summary Turn a channel on or off everywhere
 */
export const putNotificationsChannelSettingsChannel = async (
  channel: string,
  putNotificationsChannelSettingsChannelBody: PutNotificationsChannelSettingsChannelBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationChannelSetting> => {
  return customFetch<NotificationChannelSetting>(
    getPutNotificationsChannelSettingsChannelUrl(channel),
    {
      ...options,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', ...options?.headers },
      body: JSON.stringify(putNotificationsChannelSettingsChannelBody),
    },
  )
}

export const getPutNotificationsChannelSettingsChannelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>,
    TError,
    { channel: string; data: PutNotificationsChannelSettingsChannelBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>,
  TError,
  { channel: string; data: PutNotificationsChannelSettingsChannelBody },
  TContext
> => {
  const mutationKey = ['putNotificationsChannelSettingsChannel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>,
    { channel: string; data: PutNotificationsChannelSettingsChannelBody }
  > = (props) => {
    const { channel, data } = props ?? {}

    return putNotificationsChannelSettingsChannel(channel, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PutNotificationsChannelSettingsChannelMutationResult = NonNullable<
  Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>
>
export type PutNotificationsChannelSettingsChannelMutationBody =
  PutNotificationsChannelSettingsChannelBody
export type PutNotificationsChannelSettingsChannelMutationError = unknown

/**
 * @summary Turn a channel on or off everywhere
 */
export const usePutNotificationsChannelSettingsChannel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>,
      TError,
      { channel: string; data: PutNotificationsChannelSettingsChannelBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putNotificationsChannelSettingsChannel>>,
  TError,
  { channel: string; data: PutNotificationsChannelSettingsChannelBody },
  TContext
> => {
  return useMutation(getPutNotificationsChannelSettingsChannelMutationOptions(options), queryClient)
}
export const getGetNotificationsUrl = (params?: GetNotificationsParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/notifications?${stringifiedParams}`
    : `/api/v1/notifications`
}

/**
 * @summary What the system has noticed
 */
export const getNotifications = async (
  params?: GetNotificationsParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationPage> => {
  return customFetch<NotificationPage>(getGetNotificationsUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsQueryKey = (params?: GetNotificationsParams) => {
  return [`/api/v1/notifications`, ...(params ? [params] : [])] as const
}

export const getGetNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) =>
    getNotifications(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = unknown

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params: undefined | GetNotificationsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What the system has noticed
 */

export function useGetNotifications<
  TData = Awaited<ReturnType<typeof getNotifications>>,
  TError = unknown,
>(
  params?: GetNotificationsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostNotificationsUrl = () => {
  return `/api/v1/notifications`
}

/**
 * @summary Raise a notification
 */
export const postNotifications = async (
  newNotification: NewNotification,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostNotificationsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(newNotification),
  })
}

export const getPostNotificationsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotifications>>,
    TError,
    { data: NewNotification },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotifications>>,
  TError,
  { data: NewNotification },
  TContext
> => {
  const mutationKey = ['postNotifications']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotifications>>,
    { data: NewNotification }
  > = (props) => {
    const { data } = props ?? {}

    return postNotifications(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotifications>>
>
export type PostNotificationsMutationBody = NewNotification
export type PostNotificationsMutationError = unknown

/**
 * @summary Raise a notification
 */
export const usePostNotifications = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotifications>>,
      TError,
      { data: NewNotification },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotifications>>,
  TError,
  { data: NewNotification },
  TContext
> => {
  return useMutation(getPostNotificationsMutationOptions(options), queryClient)
}
export const getPostNotificationsIdReadUrl = (id: number) => {
  return `/api/v1/notifications/${id}/read`
}

/**
 * @summary Mark one as read
 */
export const postNotificationsIdRead = async (
  id: number,
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostNotificationsIdReadUrl(id), {
    ...options,
    method: 'POST',
  })
}

export const getPostNotificationsIdReadMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsIdRead>>,
    TError,
    { id: number },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsIdRead>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['postNotificationsIdRead']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsIdRead>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {}

    return postNotificationsIdRead(id, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsIdReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsIdRead>>
>

export type PostNotificationsIdReadMutationError = unknown

/**
 * @summary Mark one as read
 */
export const usePostNotificationsIdRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotificationsIdRead>>,
      TError,
      { id: number },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotificationsIdRead>>,
  TError,
  { id: number },
  TContext
> => {
  return useMutation(getPostNotificationsIdReadMutationOptions(options), queryClient)
}
export const getPostNotificationsTestSendChannelUrl = (channel: string) => {
  return `/api/v1/notifications/test-send/${channel}`
}

/**
 * @summary Send a test message on one channel
 */
export const postNotificationsTestSendChannel = async (
  channel: string,
  postNotificationsTestSendChannelBody: PostNotificationsTestSendChannelBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationTestSent> => {
  return customFetch<NotificationTestSent>(getPostNotificationsTestSendChannelUrl(channel), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postNotificationsTestSendChannelBody),
  })
}

export const getPostNotificationsTestSendChannelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsTestSendChannel>>,
    TError,
    { channel: string; data: PostNotificationsTestSendChannelBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsTestSendChannel>>,
  TError,
  { channel: string; data: PostNotificationsTestSendChannelBody },
  TContext
> => {
  const mutationKey = ['postNotificationsTestSendChannel']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsTestSendChannel>>,
    { channel: string; data: PostNotificationsTestSendChannelBody }
  > = (props) => {
    const { channel, data } = props ?? {}

    return postNotificationsTestSendChannel(channel, data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsTestSendChannelMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsTestSendChannel>>
>
export type PostNotificationsTestSendChannelMutationBody = PostNotificationsTestSendChannelBody
export type PostNotificationsTestSendChannelMutationError = unknown

/**
 * @summary Send a test message on one channel
 */
export const usePostNotificationsTestSendChannel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotificationsTestSendChannel>>,
      TError,
      { channel: string; data: PostNotificationsTestSendChannelBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotificationsTestSendChannel>>,
  TError,
  { channel: string; data: PostNotificationsTestSendChannelBody },
  TContext
> => {
  return useMutation(getPostNotificationsTestSendChannelMutationOptions(options), queryClient)
}
export const getGetNotificationsTemplatesUrl = () => {
  return `/api/v1/notifications/templates`
}

/**
 * @summary The per-event, per-channel message wording (stored, not yet applied - FB-463)
 */
export const getNotificationsTemplates = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationTemplate[]> => {
  return customFetch<NotificationTemplate[]>(getGetNotificationsTemplatesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsTemplatesQueryKey = () => {
  return [`/api/v1/notifications/templates`] as const
}

export const getGetNotificationsTemplatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsTemplates>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsTemplates>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsTemplatesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsTemplates>>> = ({
    signal,
  }) => getNotificationsTemplates({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsTemplates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsTemplatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsTemplates>>
>
export type GetNotificationsTemplatesQueryError = unknown

export function useGetNotificationsTemplates<
  TData = Awaited<ReturnType<typeof getNotificationsTemplates>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsTemplates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsTemplates>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsTemplates<
  TData = Awaited<ReturnType<typeof getNotificationsTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsTemplates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsTemplates>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsTemplates>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsTemplates<
  TData = Awaited<ReturnType<typeof getNotificationsTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsTemplates>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The per-event, per-channel message wording (stored, not yet applied - FB-463)
 */

export function useGetNotificationsTemplates<
  TData = Awaited<ReturnType<typeof getNotificationsTemplates>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsTemplates>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsTemplatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostNotificationsTemplatesUrl = () => {
  return `/api/v1/notifications/templates`
}

/**
 * @summary Write the wording for one event on one channel (stored, not yet applied - FB-463)
 */
export const postNotificationsTemplates = async (
  postNotificationsTemplatesBody: PostNotificationsTemplatesBody,
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationTemplate> => {
  return customFetch<NotificationTemplate>(getPostNotificationsTemplatesUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(postNotificationsTemplatesBody),
  })
}

export const getPostNotificationsTemplatesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsTemplates>>,
    TError,
    { data: PostNotificationsTemplatesBody },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsTemplates>>,
  TError,
  { data: PostNotificationsTemplatesBody },
  TContext
> => {
  const mutationKey = ['postNotificationsTemplates']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsTemplates>>,
    { data: PostNotificationsTemplatesBody }
  > = (props) => {
    const { data } = props ?? {}

    return postNotificationsTemplates(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsTemplatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsTemplates>>
>
export type PostNotificationsTemplatesMutationBody = PostNotificationsTemplatesBody
export type PostNotificationsTemplatesMutationError = unknown

/**
 * @summary Write the wording for one event on one channel (stored, not yet applied - FB-463)
 */
export const usePostNotificationsTemplates = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotificationsTemplates>>,
      TError,
      { data: PostNotificationsTemplatesBody },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotificationsTemplates>>,
  TError,
  { data: PostNotificationsTemplatesBody },
  TContext
> => {
  return useMutation(getPostNotificationsTemplatesMutationOptions(options), queryClient)
}
export const getPostNotificationsReadAllUrl = () => {
  return `/api/v1/notifications/read-all`
}

/**
 * @summary Mark everything as read
 */
export const postNotificationsReadAll = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<void> => {
  return customFetch<void>(getPostNotificationsReadAllUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostNotificationsReadAllMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsReadAll>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsReadAll>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postNotificationsReadAll']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsReadAll>>,
    void
  > = () => {
    return postNotificationsReadAll(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsReadAllMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsReadAll>>
>

export type PostNotificationsReadAllMutationError = unknown

/**
 * @summary Mark everything as read
 */
export const usePostNotificationsReadAll = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotificationsReadAll>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotificationsReadAll>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostNotificationsReadAllMutationOptions(options), queryClient)
}
export const getPostNotificationsDailyCheckUrl = () => {
  return `/api/v1/notifications/daily-check`
}

/**
 * @summary Run the daily check
 */
export const postNotificationsDailyCheck = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<DailyCheckResult> => {
  return customFetch<DailyCheckResult>(getPostNotificationsDailyCheckUrl(), {
    ...options,
    method: 'POST',
  })
}

export const getPostNotificationsDailyCheckMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postNotificationsDailyCheck>>,
    TError,
    void,
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postNotificationsDailyCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postNotificationsDailyCheck']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postNotificationsDailyCheck>>,
    void
  > = () => {
    return postNotificationsDailyCheck(requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostNotificationsDailyCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof postNotificationsDailyCheck>>
>

export type PostNotificationsDailyCheckMutationError = unknown

/**
 * @summary Run the daily check
 */
export const usePostNotificationsDailyCheck = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postNotificationsDailyCheck>>,
      TError,
      void,
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postNotificationsDailyCheck>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getPostNotificationsDailyCheckMutationOptions(options), queryClient)
}
export const getGetEmployeesMyPushSubscriptionUrl = () => {
  return `/api/v1/employees/my-push-subscription`
}

/**
 * @summary Whether push to your phone works and how many phones you registered
 */
export const getEmployeesMyPushSubscription = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierPushState> => {
  return customFetch<CourierPushState>(getGetEmployeesMyPushSubscriptionUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetEmployeesMyPushSubscriptionQueryKey = () => {
  return [`/api/v1/employees/my-push-subscription`] as const
}

export const getGetEmployeesMyPushSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetEmployeesMyPushSubscriptionQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>> = ({
    signal,
  }) => getEmployeesMyPushSubscription({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmployeesMyPushSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>
>
export type GetEmployeesMyPushSubscriptionQueryError = unknown

export function useGetEmployeesMyPushSubscription<
  TData = Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyPushSubscription<
  TData = Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
          TError,
          Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmployeesMyPushSubscription<
  TData = Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Whether push to your phone works and how many phones you registered
 */

export function useGetEmployeesMyPushSubscription<
  TData = Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEmployeesMyPushSubscription>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEmployeesMyPushSubscriptionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getPostEmployeesMyPushSubscriptionUrl = () => {
  return `/api/v1/employees/my-push-subscription`
}

/**
 * @summary Register this phone for the push when an order waits for a courier
 */
export const postEmployeesMyPushSubscription = async (
  courierPushSubscribeRequest: CourierPushSubscribeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierPushState> => {
  return customFetch<CourierPushState>(getPostEmployeesMyPushSubscriptionUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(courierPushSubscribeRequest),
  })
}

export const getPostEmployeesMyPushSubscriptionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>,
    TError,
    { data: CourierPushSubscribeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>,
  TError,
  { data: CourierPushSubscribeRequest },
  TContext
> => {
  const mutationKey = ['postEmployeesMyPushSubscription']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>,
    { data: CourierPushSubscribeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return postEmployeesMyPushSubscription(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type PostEmployeesMyPushSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>
>
export type PostEmployeesMyPushSubscriptionMutationBody = CourierPushSubscribeRequest
export type PostEmployeesMyPushSubscriptionMutationError = unknown

/**
 * @summary Register this phone for the push when an order waits for a courier
 */
export const usePostEmployeesMyPushSubscription = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>,
      TError,
      { data: CourierPushSubscribeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postEmployeesMyPushSubscription>>,
  TError,
  { data: CourierPushSubscribeRequest },
  TContext
> => {
  return useMutation(getPostEmployeesMyPushSubscriptionMutationOptions(options), queryClient)
}
export const getDeleteEmployeesMyPushSubscriptionUrl = () => {
  return `/api/v1/employees/my-push-subscription`
}

/**
 * @summary Stop the push to this phone
 */
export const deleteEmployeesMyPushSubscription = async (
  courierPushUnsubscribeRequest: CourierPushUnsubscribeRequest,
  options?: Parameters<typeof customFetch>[1],
): Promise<CourierPushState> => {
  return customFetch<CourierPushState>(getDeleteEmployeesMyPushSubscriptionUrl(), {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(courierPushUnsubscribeRequest),
  })
}

export const getDeleteEmployeesMyPushSubscriptionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>,
    TError,
    { data: CourierPushUnsubscribeRequest },
    TContext
  >
  request?: SecondParameter<typeof customFetch>
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>,
  TError,
  { data: CourierPushUnsubscribeRequest },
  TContext
> => {
  const mutationKey = ['deleteEmployeesMyPushSubscription']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>,
    { data: CourierPushUnsubscribeRequest }
  > = (props) => {
    const { data } = props ?? {}

    return deleteEmployeesMyPushSubscription(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type DeleteEmployeesMyPushSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>
>
export type DeleteEmployeesMyPushSubscriptionMutationBody = CourierPushUnsubscribeRequest
export type DeleteEmployeesMyPushSubscriptionMutationError = unknown

/**
 * @summary Stop the push to this phone
 */
export const useDeleteEmployeesMyPushSubscription = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>,
      TError,
      { data: CourierPushUnsubscribeRequest },
      TContext
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteEmployeesMyPushSubscription>>,
  TError,
  { data: CourierPushUnsubscribeRequest },
  TContext
> => {
  return useMutation(getDeleteEmployeesMyPushSubscriptionMutationOptions(options), queryClient)
}
export const getGetNotificationsUnreadCountUrl = () => {
  return `/api/v1/notifications/unread-count`
}

/**
 * @summary How many are unread
 */
export const getNotificationsUnreadCount = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationUnreadCount> => {
  return customFetch<NotificationUnreadCount>(getGetNotificationsUnreadCountUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsUnreadCountQueryKey = () => {
  return [`/api/v1/notifications/unread-count`] as const
}

export const getGetNotificationsUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsUnreadCountQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsUnreadCount>>> = ({
    signal,
  }) => getNotificationsUnreadCount({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsUnreadCount>>
>
export type GetNotificationsUnreadCountQueryError = unknown

export function useGetNotificationsUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsUnreadCount>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How many are unread
 */

export function useGetNotificationsUnreadCount<
  TData = Awaited<ReturnType<typeof getNotificationsUnreadCount>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsUnreadCount>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsUnreadCountQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsPushMessagesUrl = () => {
  return `/api/v1/notifications/push-messages`
}

/**
 * @summary The text of each push notification, and what is typed over it
 */
export const getNotificationsPushMessages = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<PushMessageTemplate[]> => {
  return customFetch<PushMessageTemplate[]>(getGetNotificationsPushMessagesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsPushMessagesQueryKey = () => {
  return [`/api/v1/notifications/push-messages`] as const
}

export const getGetNotificationsPushMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsPushMessages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPushMessages>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsPushMessagesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsPushMessages>>> = ({
    signal,
  }) => getNotificationsPushMessages({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsPushMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsPushMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsPushMessages>>
>
export type GetNotificationsPushMessagesQueryError = unknown

export function useGetNotificationsPushMessages<
  TData = Awaited<ReturnType<typeof getNotificationsPushMessages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPushMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsPushMessages>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsPushMessages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsPushMessages<
  TData = Awaited<ReturnType<typeof getNotificationsPushMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPushMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsPushMessages>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsPushMessages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsPushMessages<
  TData = Awaited<ReturnType<typeof getNotificationsPushMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPushMessages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The text of each push notification, and what is typed over it
 */

export function useGetNotificationsPushMessages<
  TData = Awaited<ReturnType<typeof getNotificationsPushMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsPushMessages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsPushMessagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsHealthUrl = () => {
  return `/api/v1/notifications/health`
}

/**
 * @summary How each channel has been doing over the last day
 */
export const getNotificationsHealth = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationChannelHealth[]> => {
  return customFetch<NotificationChannelHealth[]>(getGetNotificationsHealthUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsHealthQueryKey = () => {
  return [`/api/v1/notifications/health`] as const
}

export const getGetNotificationsHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsHealth>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsHealthQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsHealth>>> = ({ signal }) =>
    getNotificationsHealth({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsHealth>>
>
export type GetNotificationsHealthQueryError = unknown

export function useGetNotificationsHealth<
  TData = Awaited<ReturnType<typeof getNotificationsHealth>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsHealth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsHealth>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsHealth<
  TData = Awaited<ReturnType<typeof getNotificationsHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsHealth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsHealth>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsHealth>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsHealth<
  TData = Awaited<ReturnType<typeof getNotificationsHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsHealth>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How each channel has been doing over the last day
 */

export function useGetNotificationsHealth<
  TData = Awaited<ReturnType<typeof getNotificationsHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsHealth>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsEmailMessagesUrl = () => {
  return `/api/v1/notifications/email-messages`
}

/**
 * @summary The text of each e-mail the system sends, and what is typed over it
 */
export const getNotificationsEmailMessages = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<EmailMessageTemplate[]> => {
  return customFetch<EmailMessageTemplate[]>(getGetNotificationsEmailMessagesUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsEmailMessagesQueryKey = () => {
  return [`/api/v1/notifications/email-messages`] as const
}

export const getGetNotificationsEmailMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsEmailMessages>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsEmailMessagesQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsEmailMessages>>> = ({
    signal,
  }) => getNotificationsEmailMessages({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsEmailMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsEmailMessages>>
>
export type GetNotificationsEmailMessagesQueryError = unknown

export function useGetNotificationsEmailMessages<
  TData = Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsEmailMessages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsEmailMessages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsEmailMessages<
  TData = Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsEmailMessages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsEmailMessages>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsEmailMessages<
  TData = Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsEmailMessages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The text of each e-mail the system sends, and what is typed over it
 */

export function useGetNotificationsEmailMessages<
  TData = Awaited<ReturnType<typeof getNotificationsEmailMessages>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsEmailMessages>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsEmailMessagesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsDeliveriesUrl = (params?: GetNotificationsDeliveriesParams) => {
  const normalizedParams = new URLSearchParams()

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  })

  const stringifiedParams = normalizedParams.toString()

  return stringifiedParams.length > 0
    ? `/api/v1/notifications/deliveries?${stringifiedParams}`
    : `/api/v1/notifications/deliveries`
}

/**
 * @summary What actually went out, and what did not
 */
export const getNotificationsDeliveries = async (
  params?: GetNotificationsDeliveriesParams,
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationDelivery[]> => {
  return customFetch<NotificationDelivery[]>(getGetNotificationsDeliveriesUrl(params), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsDeliveriesQueryKey = (
  params?: GetNotificationsDeliveriesParams,
) => {
  return [`/api/v1/notifications/deliveries`, ...(params ? [params] : [])] as const
}

export const getGetNotificationsDeliveriesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsDeliveries>>,
  TError = unknown,
>(
  params?: GetNotificationsDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsDeliveries>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsDeliveriesQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsDeliveries>>> = ({
    signal,
  }) => getNotificationsDeliveries(params, { signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsDeliveries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsDeliveriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsDeliveries>>
>
export type GetNotificationsDeliveriesQueryError = unknown

export function useGetNotificationsDeliveries<
  TData = Awaited<ReturnType<typeof getNotificationsDeliveries>>,
  TError = unknown,
>(
  params: undefined | GetNotificationsDeliveriesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsDeliveries>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsDeliveries>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsDeliveries>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsDeliveries<
  TData = Awaited<ReturnType<typeof getNotificationsDeliveries>>,
  TError = unknown,
>(
  params?: GetNotificationsDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsDeliveries>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsDeliveries>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsDeliveries>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsDeliveries<
  TData = Awaited<ReturnType<typeof getNotificationsDeliveries>>,
  TError = unknown,
>(
  params?: GetNotificationsDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsDeliveries>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary What actually went out, and what did not
 */

export function useGetNotificationsDeliveries<
  TData = Awaited<ReturnType<typeof getNotificationsDeliveries>>,
  TError = unknown,
>(
  params?: GetNotificationsDeliveriesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsDeliveries>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsDeliveriesQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsChannelsUrl = () => {
  return `/api/v1/notifications/channels`
}

/**
 * @summary How each event reaches the customer
 */
export const getNotificationsChannels = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationChannels> => {
  return customFetch<NotificationChannels>(getGetNotificationsChannelsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsChannelsQueryKey = () => {
  return [`/api/v1/notifications/channels`] as const
}

export const getGetNotificationsChannelsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsChannels>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannels>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsChannelsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsChannels>>> = ({
    signal,
  }) => getNotificationsChannels({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsChannels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsChannelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsChannels>>
>
export type GetNotificationsChannelsQueryError = unknown

export function useGetNotificationsChannels<
  TData = Awaited<ReturnType<typeof getNotificationsChannels>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannels>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannels<
  TData = Awaited<ReturnType<typeof getNotificationsChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannels>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannels>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannels<
  TData = Awaited<ReturnType<typeof getNotificationsChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannels>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How each event reaches the customer
 */

export function useGetNotificationsChannels<
  TData = Awaited<ReturnType<typeof getNotificationsChannels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannels>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsChannelsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsChannelsCoverageUrl = () => {
  return `/api/v1/notifications/channels/coverage`
}

/**
 * @summary How many customers each notification channel can reach
 */
export const getNotificationsChannelsCoverage = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<ChannelCoverage> => {
  return customFetch<ChannelCoverage>(getGetNotificationsChannelsCoverageUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsChannelsCoverageQueryKey = () => {
  return [`/api/v1/notifications/channels/coverage`] as const
}

export const getGetNotificationsChannelsCoverageQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsChannelsCoverageQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>> = ({
    signal,
  }) => getNotificationsChannelsCoverage({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsChannelsCoverageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>
>
export type GetNotificationsChannelsCoverageQueryError = unknown

export function useGetNotificationsChannelsCoverage<
  TData = Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannelsCoverage<
  TData = Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannelsCoverage<
  TData = Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary How many customers each notification channel can reach
 */

export function useGetNotificationsChannelsCoverage<
  TData = Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelsCoverage>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsChannelsCoverageQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}

export const getGetNotificationsChannelSettingsUrl = () => {
  return `/api/v1/notifications/channel-settings`
}

/**
 * @summary The per-channel master switches, and whether a channel is degraded
 */
export const getNotificationsChannelSettings = async (
  options?: Parameters<typeof customFetch>[1],
): Promise<NotificationChannelSetting[]> => {
  return customFetch<NotificationChannelSetting[]>(getGetNotificationsChannelSettingsUrl(), {
    ...options,
    method: 'GET',
  })
}

export const getGetNotificationsChannelSettingsQueryKey = () => {
  return [`/api/v1/notifications/channel-settings`] as const
}

export const getGetNotificationsChannelSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelSettings>>, TError, TData>
  >
  request?: SecondParameter<typeof customFetch>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetNotificationsChannelSettingsQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsChannelSettings>>> = ({
    signal,
  }) => getNotificationsChannelSettings({ signal, ...requestOptions })

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsChannelSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNotificationsChannelSettings>>
>
export type GetNotificationsChannelSettingsQueryError = unknown

export function useGetNotificationsChannelSettings<
  TData = Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannelSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannelSettings<
  TData = Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsChannelSettings>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsChannelSettings<
  TData = Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelSettings>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary The per-channel master switches, and whether a channel is degraded
 */

export function useGetNotificationsChannelSettings<
  TData = Awaited<ReturnType<typeof getNotificationsChannelSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getNotificationsChannelSettings>>, TError, TData>
    >
    request?: SecondParameter<typeof customFetch>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationsChannelSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  return withQueryKey(query, queryOptions.queryKey)
}
